import { Environment } from './environment.model';

export const environment: Environment = {
   production: false,
   stage: true,
   reloadOnUpdate: true,
   defaultApiUrl: 'https://api.stage.summerrockz.com',
   customApiUrls: {
      'stage.summerrockz-app.com': 'https://api.stage.summerrockz-app.com',
      'stage.ticket-reservation-app.com': 'https://api.stage.ticket-reservation-app.com',
   },
   gaMeasurementId: 'G-GRS332F9XP',
   googleMapsApiKey: 'AIzaSyAnQOIs8MnSnlgbYVVjcqiXzZzm1hDwf_U',
};
